import React, { useState, useEffect, useRef } from 'react';
import Modal from 'components/Modals/Modal.js';
// Alertify
import alertify from 'alertifyjs';

const TableDropdown = ({
  rowDataId,
  rowDataName,
  rowDataActive,
  info,
  URIExtension,
  ...props
}) => {
  function useComponentVisible(initialIsVisible) {
    const [isComponentVisible, setIsComponentVisible] =
      useState(initialIsVisible);
    const ref = useRef(null);

    const handleHideDropdown = (event) => {
      if (event.key === 'Escape') {
        closeDropdownPopover();
      }
    };

    const handleClickOutside = (event) => {
      if (ref.current && !btnDropdownRef.current.contains(event.target)) {
        closeDropdownPopover();
      }
    };

    useEffect(() => {
      document.addEventListener('keydown', handleHideDropdown, true);
      document.addEventListener('click', handleClickOutside, true);
      return () => {
        document.removeEventListener('keydown', handleHideDropdown, true);
        document.removeEventListener('click', handleClickOutside, true);
      };
    });

    return { ref, isComponentVisible, setIsComponentVisible };
  }

  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible();

  // useState
  const [idData, setIdData] = useState('');
  const [nameDataRow, setNameDataRow] = useState('');
  const [activeDataRow, setActiveDataRow] = useState('');
  // Alerts
  const [alert, setAlert] = useState('');
  // URI
  const URI = '/api/update/';
  // URI For Remove (Set State to 2)
  const URIDelete = '/api/delete/';

  if (alert) {
    if (!alertify.errorAlert) {
      alertify.dialog(
        'errorAlert',
        function factory() {
          return {
            build: function () {
              var errorHeader =
                '<span class="fas fa-info-circle fa-2x" ' +
                'style="vertical-align:middle;color:#77acf1;">' +
                '</span><span style="vertical-align:middle;font-size:1.15em;margin: 0 .5em;">Info</span>';
              this.setHeader(errorHeader);
            },
          };
        },
        true,
        'alert'
      );
    }
    alertify.errorAlert(alert);
    setAlert('');
  }

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      setIdData(rowDataId);
      setNameDataRow(rowDataName);
      setActiveDataRow(rowDataActive);
    }

    return () => {
      mounted = false;
    };
  }, [rowDataId, rowDataName, rowDataActive]);

  function submitDataEdit() {
    var datos = [];

    datos.push({
      idData,
      nameDataRow,
      activeDataRow,
    });

    fetch(URI + URIExtension, {
      method: 'PUT',
      credentials: 'same-origin',
      withCredentials: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(datos),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          setAlert(result.message);
        }
        props.recibir();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function submitDataRemove() {
    var datos = [];

    datos.push({
      idData,
    });

    fetch(URIDelete + URIExtension, {
      method: 'PUT',
      credentials: 'same-origin',
      withCredentials: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(datos),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          setAlert(result.message);
        }
        props.recibir();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const handleSubmitEdit = (evt) => {
    evt.preventDefault();
    submitDataEdit();
  };
  const handleSubmitRemove = (evt) => {
    evt.preventDefault();
    submitDataRemove();
  };
  const modalEdit = useRef(null);
  const modalRemove = useRef(null);

  return (
    <>
      <a
        className='text-gray-600 py-1 px-3'
        href=' '
        ref={btnDropdownRef}
        onClick={(e) => {
          e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
          dropdownPopoverShow
            ? closeDropdownPopover()
            : setIsComponentVisible(true);
        }}>
        <i className='fas fa-ellipsis-v'></i>
      </a>

      <div
        ref={popoverDropdownRef}
        className={
          'bg-white text-base z-50 float-left py-2 list-none text-left rounded-md shadow-lg w-36 ' +
          (dropdownPopoverShow ? 'message-globe' : 'hide-message')
        }>
        {isComponentVisible && (
          <div ref={ref}>
            <a
              href=' '
              className={
                'edit-option text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800'
              }
              onClick={(e) => {
                e.preventDefault();
                modalEdit.current.open();
              }}>
              <i className='far fa-edit mr-2'></i>
              Editar
            </a>
            <a
              href=' '
              className={
                'delete-option text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800'
              }
              onClick={(e) => {
                e.preventDefault();
                modalRemove.current.open();
              }}>
              <i className='fas fa-eraser mr-2'></i>
              Eliminar
            </a>
          </div>
        )}
      </div>

      <Modal ref={modalEdit}>
        <form onSubmit={handleSubmitEdit}>
          <div className='text-gray-300 font-bold md:text-left mb-1 md:mb-0 pr-4'>
            Editar {info}
          </div>
          <div className='my-4 md:block flex items-center justify-center max-w-full'>
            <label
              htmlFor={'nombre' + info}
              className='text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4 max-w-1/2 w-1/2 inline-block'>
              Nombre de {info}
            </label>
            <input
              className='bg-gray-200 appearance-none border-2 border-gray-200 rounded py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-blue-500 max-w-1/2 w-1/2 inline-block'
              type='text'
              id={'nombre' + info}
              name={'nombre' + info}
              placeholder={'Nombre de ' + info}
              onChange={(e) => setNameDataRow(e.target.value)}
              value={nameDataRow}></input>
          </div>
          <div className='my-4 md:block flex items-center justify-center max-w-full'>
            <label
              htmlFor={'activo' + info}
              className='text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4 max-w-1/2 w-1/2 inline-block'>
              Estado de {info}
            </label>
            <select
              className='bg-gray-200 appearance-none border-2 border-gray-200 rounded py-2 px-6 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-blue-500 max-w-1/2 w-1/2 inline-block'
              placeholder={'Estado de ' + info}
              onChange={(e) => setActiveDataRow(e.target.value)}
              value={activeDataRow}>
              <option value='1'>Activo</option>
              <option value='2'>No activo</option>
            </select>
          </div>
          <div className='flex'>
            <button
              type='button'
              className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 my-3 rounded mr-2 max-w-1/2 w-1/2'
              onClick={() => modalEdit.current.close()}>
              Cerrar ventana
            </button>
            <button
              type='submit'
              className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 my-3 rounded ml-2 max-w-1/2 w-1/2'
              // onClick={(e) => {e.preventDefault();}}
            >
              Guardar cambios
            </button>
          </div>
        </form>
      </Modal>
      <Modal ref={modalRemove}>
        <form onSubmit={handleSubmitRemove}>
          <div className='text-gray-300 font-bold md:text-left mb-1 md:mb-0 pr-4'>
            Eliminar {info}
          </div>
          <div className='my-4'>
            <label
              htmlFor={'nombre' + info}
              className='text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4'>
              En verdad desea eliminar este/a {info}?
            </label>
            <div className='my-4'>
              <div className='flex'>
                <button
                  type='button'
                  className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 mt-3.5 rounded mr-2 whitespace-pre-line'
                  onClick={() => modalRemove.current.close()}>
                  No, cerrar ventana
                </button>
                <button
                  type='submit'
                  className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 mt-3.5 rounded ml-2 whitespace-pre-line'
                  // onClick={(e) => {e.preventDefault();}}
                >
                  Si, deseo eliminarlo
                </button>
              </div>
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default TableDropdown;
